define('lq/events/actions/businessLogicBlockCommand',[
    'underscore',
    'lq/events/actions/eventAction',
    'lq/validatorGateway'
], function (_, EventAction, validatorGateway) {
    'use strict';

    function BusinessLogicBlockCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(BusinessLogicBlockCommand, EventAction);

    BusinessLogicBlockCommand.typeName = 'BusinessLogicBlockCommand';

    BusinessLogicBlockCommand.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    BusinessLogicBlockCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'BusinessLogicBlockCommand',
            command: this.eventData.command
        };
    };

    BusinessLogicBlockCommand.prototype.execute = function (continuation, eventActionResponse) {
        if(validatorGateway.isEnabled())
            this.runTrace(eventActionResponse.trace, this.rootDrop.instanceId, this.eventActionId);
        
        this.triggerEvents(continuation, eventActionResponse);        
    };

    BusinessLogicBlockCommand.prototype.triggerEvents = function (continuation, eventActionResponse) {
        var self = this;
        var firstContinuation = _.reduce(eventActionResponse.events.reverse(), function (nextContinuation, theEvent) {
            return function (options) {
                if(options?.break) {
                    nextContinuation(options);
                }
                else {
                    var eventName = theEvent.eventName.charAt(0).toLowerCase() + theEvent.eventName.slice(1)
                    self.triggerEvent(eventName, nextContinuation, theEvent.value);
                }
                
            }
        }, continuation);

        firstContinuation();
    };

    BusinessLogicBlockCommand.prototype.runTrace = function (trace, parentActionInstanceId, parentEventActionId) {
        if (!trace || trace.length === 0)
            return

        var actionInstanceId = this.rootDrop.__proto__.constructor.nextInstanceId();
        var eventId = 0;
        var eventActionId = 0;

        var self = this;
        _.each(trace, function (event) {
            eventId++;

            var entering = {
                type: 'ENTERING_EVENT',
                status:  event.entered ? 'EXECUTING' : 'SKIPPING',
                actionInstanceId: actionInstanceId,
                id: eventId,
                name: event.eventName,
                parentEventAction: {
                    id: parentEventActionId,
                    actionInstanceId: parentActionInstanceId
                },
                condition: event.condition,
                locals: event.locals,
                globals: event.globals,
                systems: event.systems
            };
            
            validatorGateway.publishEvent(entering);

            _.each(event.eventActions, function (eventAction) {
                eventActionId++;

                validatorGateway.publishEvent({
                    type: 'CREATED_EVENT_ACTION',
                    actionInstanceId: actionInstanceId,
                    id: eventActionId,
                    eventId: eventId,
                    eventActionData: eventAction.data
                });

                validatorGateway.publishEvent({
                    type: 'EXECUTING_EVENT_ACTION',
                    actionInstanceId: actionInstanceId,
                    id: eventActionId,
                    eventId: eventId,
                    eventActionTypeName: eventAction.data.eventActionType,
                    locals: {},
                    globals: {},
                    systems: {}
                });

                validatorGateway.publishEvent({
                    type: 'HANDLING_EVENT_ACTION_RESPONSE',
                    actionInstanceId: actionInstanceId,
                    id: eventActionId,
                    eventId: eventId,
                    eventActionTypeName: eventAction.data.eventActionType,
                    location: 'SERVER',
                    locals: eventAction.debug.beforeParameters.locals,
                    globals: eventAction.debug.beforeParameters.globals,
                    systems: eventAction.debug.systems,
                });

                if(eventAction.events) {
                    self.runTrace(eventAction.events, actionInstanceId, eventActionId);
                }
                
                validatorGateway.publishEvent({
                    type: 'EXECUTED_EVENT_ACTION',
                    actionInstanceId: actionInstanceId,
                    id: eventActionId,
                    locals: eventAction.debug.afterParameters.locals,
                    globals: eventAction.debug.afterParameters.globals
                });
            });
        });
    };

    return BusinessLogicBlockCommand;
});
